<template>
  <v-sheet
    v-ripple
    @click="viewIncompleteStaff"
    rounded
    v-if="hasStaffPermission"
    class="pa-3 card ma-2 ma-md-5 text-center"
    :elevation="4"
  >
  <div class="snapbox">
    <div style="font-weight: bold; font-size: 14;">Staff Incomplete</div>
    {{ incompleteStaffCount }} 
  </div>
    

    <v-dialog scrollable v-model="showDialog" max-width="350px">
      <v-card class="pa-2">
        <v-card-title class="justify-space-between">
          <div>Incomplete Staff</div>
          <div>
            <v-btn @click="showDialog = null" icon
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-divider></v-divider>

        <div class="my-2 text-center text-caption">
          Found {{ pagination.totalSize }}
          <span v-if="pagination.totalSize >= pagination.pageSize"
            >, showing {{ pagination.pageSize }} results</span
          >
          <span v-else>results</span>
        </div>
        <v-list shaped>
          <v-list-item-group v-model="selectedStaff" color="primary">
            <v-list-item
              @click="view(staff)"
              v-for="staff in StaffList"
              :key="staff.id"
            >
              <v-list-item-content>
                <v-list-item-title
                  >{{ staff.firstName }} {{ staff.lastName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ staff.contactTypeName }} ({{ ageGender(staff) }})
                  <span v-if="!staff.active"
                    ><v-divider vertical />(Inactive)</span
                  >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <a class="nostyle mt-2" @click="$router.push({ name: 'staff' })"> View more... </a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { Role } from "@/router/_helper";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      showDialog: false,
      incompleteStaffCount: 0,
      incompleteStaffList: [],
      pagination: {
        current: 1,
        pageSize: 20,
        totalSize: 100,
      },
      options: {
        sortBy: [],
        sortDesc: [],
      },
      StaffList: [],
      activeOnly: true,
      selectedStaff: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    hasStaffPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStaff) ||
        this.userRoles.includes(Role.Admin)
      );
    },
  },
  mounted() {
    this.getIncompleteStaff();
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("staff", ["fetchStaff"]),
    getIncompleteStaff() {
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        activeOnly: true,
        allRequirementComplete: false,
      };

      this.fetchStaff(params).then((response) => {
        if (response) {
          this.incompleteStaffCount = response.totalElements;
          this.incompleteStaffList = response.content;
        }
      });
    },
    viewIncompleteStaff() {
      if (this.incompleteStaffCount > 0) {
        this.showDialog = true;
        this.getResources();
      }
    },
    getResources() {
      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;

      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        activeOnly: this.activeOnly,
        allRequirementComplete: false,
      };

      this.fetchStaff(params)
        .then((response) => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.StaffList = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    view(staff) {
      this.$router.push({ name: "staffView", params: { id: staff.id } });
    },
    ageGender(staff) {
      let info = "";
      if (staff.dob) {
        const ageYears = moment().diff(staff.dob, "years", false);
        const ageMonths = moment().diff(staff.dob, "months", false) % 12;
        info += `${ageYears}y${ageMonths}m`;
      }
      if (staff.gender) {
        if (info) {
          info += ` ${staff.gender} `;
        } else {
          info = staff.gender;
        }
      }
      return info;
    },
  },
};
</script>
<style scoped>
.card {
  cursor: pointer;
}
.nostyle {
  text-decoration: none;
}

.snapbox{
  display: block;
}
@media (max-width: 1400px) {
  .snapbox {
    font-size: 12px;
  }
}
</style>